// extracted by mini-css-extract-plugin
export default {"content":"nnzIQ","text":"zbP1d"};